module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="tab-forms tab-search-tours active">\n    <span class="tab-forms__tury-icon"></span>\n    <span class="tab-select-container">Туры <span></span></span>\n</div>';
}
return __p;
};
